import axios from "../utils/axios";

export const getStoreNetwork = async (search, city_id, category ) => {
    const params = {};
    if (search) params.search = search;
    if (city_id) params.city_id = city_id;
    if (category) params.category = category;

    const { data } = await axios.get(`/user/store-network`, { params });
    return data;
};
